import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink, withRouter } from 'react-router-dom';
import classnames from 'classnames';

class SidebarLink extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    isNew: PropTypes.bool,
    route: PropTypes.string
  };

  render() {
    const { route, icon, title, isNew, onClick } = this.props;
    const isActive = window.location.pathname.includes(route);
    return (
      <li
        className={classnames('sidebar__link', {
          'active-menu-item': isActive
        })}
      >
        <NavLink
          exact
          to={route ? route : '/'}
          activeClassName="sidebar__link-active"
          onClick={onClick}
        >
          {icon ? <span className={`sidebar__link-icon ${icon}-icon`} /> : ''}
          <span className="sidebar__link-title">
            {title}
            {isNew ? (
              <Badge className="sidebar__link-badge">
                <span>New</span>
              </Badge>
            ) : (
              ''
            )}
          </span>
        </NavLink>
      </li>
    );
  }
}

export default withRouter(SidebarLink);



// WEBPACK FOOTER //
// ./src/components/sidebar/SidebarLink.js